import { Box } from '@chakra-ui/react';
import type { ReactNode } from 'react';
import { SETTINGS_BORDER_COLOR, SETTINGS_TABLE_GUTTER } from './constants';

export interface SettingsTableFooterProps {
    children: ReactNode;
}

/**
 * Bottom bar of a SettingsPage variant="table": pagination, pinned under the
 * table's scroll box. Deliberately short — the table above it is the page, so
 * the footer gives up as much height as it can while still clearing the
 * 28px pagination buttons.
 */
const SettingsTableFooter = ({ children }: SettingsTableFooterProps) => (
    <Box
        px={SETTINGS_TABLE_GUTTER}
        py={1.5}
        flexShrink={0}
        borderTopWidth="1px"
        borderColor={SETTINGS_BORDER_COLOR}
    >
        {children}
    </Box>
);

export default SettingsTableFooter;
